var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create_White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.675 13.325H5.84453C5.47641 13.325 5.16355 13.1962 4.90593 12.9386C4.64833 12.681 4.51953 12.3681 4.51953 12C4.51953 11.6319 4.64833 11.319 4.90593 11.0614C5.16355 10.8038 5.47641 10.675 5.84453 10.675H10.675V5.84453C10.675 5.47641 10.8038 5.16355 11.0614 4.90593C11.319 4.64833 11.6319 4.51953 12 4.51953C12.3681 4.51953 12.681 4.64833 12.9386 4.90593C13.1962 5.16355 13.325 5.47641 13.325 5.84453V10.675H18.1554C18.5235 10.675 18.8364 10.8038 19.094 11.0614C19.3516 11.319 19.4804 11.6319 19.4804 12C19.4804 12.3681 19.3516 12.681 19.094 12.9386C18.8364 13.1962 18.5235 13.325 18.1554 13.325H13.325V18.1554C13.325 18.5235 13.1962 18.8364 12.9386 19.094C12.681 19.3516 12.3681 19.4804 12 19.4804C11.6319 19.4804 11.319 19.3516 11.0614 19.094C10.8038 18.8364 10.675 18.5235 10.675 18.1554V13.325Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateWhite);
export default __webpack_public_path__ + "static/media/create_white.0831ea43130b7029d0150789ac2c90fb.svg";
export { ForwardRef as ReactComponent };